/**
 * Verbessert die Barrierefreiheit für das Elementor WordPress Menu Widget.
 */
function initNavOptimization() {
    // Attribute die nicht zulässig sind aber von Elementor gesetzt werden
    const forbiddenAttributes = ['aria-haspopup', 'aria-controls', 'role'];

    const cleanLink = (link) => {
        forbiddenAttributes.forEach((attr) => {
            if (link.hasAttribute(attr)) {
                link.removeAttribute(attr);
            }
        });
    };

    document.querySelectorAll('.elementor-nav-menu .has-submenu').forEach(cleanLink);

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'attributes') {
                const target = mutation.target;
                if (target && target.classList && target.classList.contains('has-submenu')) {
                    if (forbiddenAttributes.includes(mutation.attributeName) && target.hasAttribute(mutation.attributeName)) {
                        target.removeAttribute(mutation.attributeName);
                    }
                }
            }
        });
    });

    const menuContainer = document.querySelector('.elementor-nav-menu');

    const targetNode = menuContainer || document.body;

    observer.observe(targetNode, {
        attributes: true,
        subtree: true,
        attributeFilter: forbiddenAttributes
    });
}

export { initNavOptimization };